module.exports = __webpack_public_path__ + "static/media/layer_6.8378f91d.png";